import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function gameRelatedList(game_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/game/${game_id}/related/list${queryString}`,
  );
}

export async function gameRelatedGameList(game_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/game/related/${game_id}/game/list${queryString}`,
  );
}

export async function gameRelatedListId(game_id: string) {
  return await clientAxios.get(`admin/game/${game_id}/related/list/id`);
}

export async function gameRelatedListOwnerIdByGame(game_id: string) {
  return await clientAxios.get(`admin/game/related/${game_id}/list/id`);
}

export async function gameRelatedGet(item_id: string) {
  return await clientAxios.get(`admin/game/related/${item_id}/show`);
}

export async function gameRelatedCreate(game_id: string, payload: Partial<any>) {
  return await clientAxios.post(`admin/game/${game_id}/related/create`, payload);
}

export async function gameRelatedDelete(item_id: string) {
  return await clientAxios.del(`admin/game/related/${item_id}/delete`);
}
